import "./Counter.css";

const Countercard = () => {
  return (
    <div className="bg-white !py-5 md:!py-10 text-[#313F78] !px-10">
      <div className="flex flex-col justify-center items-center md:text-center">
        <h2 className="text-[16px] md:text-[32px] font-medium">
          Engineering Tomorrow's Tech Today
        </h2>
        <p className="text-[12px] md:text-[22px] md:w-[50%] text-center">
          AI-powered development, cloud-native architectures, and future-proof code designed to
          outpace your market.
        </p>
      </div>
    </div>
  );
};

export default Countercard;
